<template>
  <div class="set_type_bg">
    <div class="set_type_container">
      <div class="set_type_box">
        <div class="set_type" v-if="isShowNormal" :class="{ selected: actionSet.setType.value === SetType.routine }" @click.stop="() => changeSetType(SetType.routine)">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.routine)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.routine].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.routine].type }}</div>
          </div>
        </div>

        <div class="set_type" v-if="isShowMacro" :class="{ selected: actionSet.setType.value === SetType.macro }" @click.stop="() => changeSetType(SetType.macro)">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.macro)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.macro].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.macro].type }}</div>
          </div>
        </div>

        <div class="set_type" v-if="isSupportKME" :class="{ selected: actionSet.setType.value === SetType.kme }" @click.stop="changeSetType(SetType.kme)" @mouseenter="hoveredItem = SetType.kme" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.kme)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.kme].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.kme].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.kme)" @click.stop="showDemo(SetType.kme)" />
        </div>

        <div class="set_type" v-if="isShowMagnet && !isSelfDevMix" :class="{ selected: actionSet.setType.value === SetType.dks }" @click.stop="() => changeSetType(SetType.dks)" @mouseenter="hoveredItem = SetType.dks" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.dks)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.dks].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.dks].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.dks)" @click.stop="showDemo(SetType.dks)" />
        </div>

        <div class="set_type" v-if="isShowMPT_END && isShowMagnet" :class="{ selected: actionSet.setType.value === SetType.mpt }" @click.stop="changeSetType(SetType.mpt)" @mouseenter="hoveredItem = SetType.mpt" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.mpt)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.mpt].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.mpt].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.mpt)" @click.stop="showDemo(SetType.mpt)" />
        </div>

        <div class="set_type" v-if="isShowMPT_END && isShowMagnet" :class="{ selected: actionSet.setType.value === SetType.end }" @click.stop="() => changeSetType(SetType.end)" @mouseenter="hoveredItem = SetType.end" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.end)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.end].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.end].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.end)" @click.stop="showDemo(SetType.end)" />
        </div>

        <div class="set_type" v-if="isSupportRS && isShowMagnet" :class="{ selected: actionSet.setType.value === SetType.rs }" @click.stop="changeSetType(SetType.rs)" @mouseenter="hoveredItem = SetType.rs" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.rs)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.rs].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.rs].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.rs)" @click.stop="showDemo(SetType.rs)" />
        </div>

        <div class="set_type" v-if="isShowMagnet && !isSelfDevMix" :class="{ selected: actionSet.setType.value === SetType.mt }" @click.stop="changeSetType(SetType.mt)" @mouseenter="hoveredItem = SetType.mt" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.mt)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.mt].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.mt].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.mt)" @click.stop="showDemo(SetType.mt)" />
        </div>
        <div class="set_type" v-if="isShowMagnet && !isSelfDevMix" :class="{ selected: actionSet.setType.value === SetType.tgl }" @click.stop="changeSetType(SetType.tgl)" @mouseenter="hoveredItem = SetType.tgl" @mouseleave="hoveredItem = null">
          <div class="set_type_icon_wrapper">
            <span class="set_type_icon" :style="getSetTypeIconStyle(SetType.tgl)"></span>
          </div>
          <div class="set_type_info">
            <div class="set_type_title">{{ setTexts()[SetType.tgl].title }}</div>
            <div class="set_type_content">{{ setTexts()[SetType.tgl].type }}</div>
          </div>
          <Hint_icon class="set_type_hint" v-bind="getIconColors(SetType.tgl)" @click.stop="showDemo(SetType.tgl)" />
        </div>
      </div>
    </div>
  </div>
  <!-- set_action_explain -->
  <Set_action_explain v-if="clickedItem != null" :type="clickedItem" @close="() => (clickedItem = null)" @confirm="() => (clickedItem = null)" />
</template>
<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { actionSet, SetType } from '../../service/driver/action_set'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import firmware from '@/upgrade/firmware'
import { DeviceManager } from '@/service/device'
import { operate } from '@/service/driver/operate'
import { setData } from '@/service/driver/data'
import { DialogType, enableDialog } from '../cdialog/dialog'
import i18n from '@/languages/i18n'
import { getCurrentDevice } from '@/profiles/selector'
import { onMounted } from 'vue'
import { toRefs } from 'vue'
import { JingTaiDeviceList, JingTaiV2DeviceList } from '@/define/device_vendor'
import { DeviceCapability } from '@/service/device_capability'
import { KK } from '@/define/define'
import Hint_icon from './hint_icon.vue'
import Set_action_explain from './set_action_explain.vue'
import { HuoChaiRenDevices } from '@hid/define/define'
import { actionMessage, setTexts, isShowNormal, isShowMacro, isShowMagnet, isSupportKME, hasVisibleModes } from './action_config'
import { isActionSetTypeVisible, resolveActionVisibility } from './action_visibility_rules'
import operationBaseSvg from '@/assets/img/operation_base.svg?raw'
import operationActionSvg from '@/assets/img/operation_action.svg?raw'
import operationMgxSvg from '@/assets/img/operation_mgx.svg?raw'
import operationAdvancedSvg from '@/assets/img/operation_advanced.svg?raw'
import operationConfigSvg from '@/assets/img/operation_config.svg?raw'
import operationKmeSvg from '@/assets/img/operation_kme.svg?raw'
import operationRsSvg from '@/assets/img/operation_rs.svg?raw'
import operationMptSvg from '@/assets/img/operation_mpt.svg?raw'
import operationEndSvg from '@/assets/img/operation_end.svg?raw'

const { t } = i18n.global

const svgToDataUri = (raw: string) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(raw)}`

const setTypeIcons: Record<number, string> = {
  [SetType.routine]: svgToDataUri(operationBaseSvg),
  [SetType.macro]: svgToDataUri(operationActionSvg),
  [SetType.dks]: svgToDataUri(operationMgxSvg),
  [SetType.mt]: svgToDataUri(operationAdvancedSvg),
  [SetType.tgl]: svgToDataUri(operationConfigSvg),
  [SetType.kme]: svgToDataUri(operationKmeSvg),
  [SetType.rs]: svgToDataUri(operationRsSvg),
  [SetType.mpt]: svgToDataUri(operationMptSvg),
  [SetType.end]: svgToDataUri(operationEndSvg),
}

const getSetTypeIconStyle = (type: SetType) => {
  const uri = setTypeIcons[type] || setTypeIcons[SetType.routine]
  return {
    '--set-type-icon': `url("${uri}")`,
  }
}

const changeSetType = (type: SetType) => {
  if (type == SetType.macro) {
    if (!check_macro()) {
      return
    }
  }
  actionSet.changeSetType(type)
}
const showDemo = (type: SetType) => {
  clickedItem.value = type
}

onMounted(() => {
  init()
  uploadData()
})

const init = async () => {
  await initSupportKME()
  await initSupportRS()
}

const { currentPid } = toRefs(DeviceManager.instance.state)
watch(currentPid, () => {
  isSupportKME.value = false
  isSupportRS.value = false
  initSupportKME()
  initSupportRS()
})

const isSupportRS = ref(false)
const hoveredItem = ref<SetType | null>(null)
const clickedItem = ref<SetType | null>(null)
/* 统一的图标颜色计算 */
const getIconColors = (itemType: SetType) => ({
  circleFill: hoveredItem.value === itemType || actionSet.setType.value === itemType ? '#fff' : 'transparent',
  circleStroke: hoveredItem.value === itemType || actionSet.setType.value === itemType ? '#fff' : 'rgba(0,0,0,0.2)',
  textFill: hoveredItem.value === itemType || actionSet.setType.value === itemType ? 'var(--brand-color-pure)' : 'rgba(0,0,0,0.4)',
})

const initSupportRS = async () => {
  isSupportRS.value = (await firmware.versionIs20241125a()) || (specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V2) && (await firmware.jingtaiV2_isSupportRS())) || specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen)
}
// 晶泰的设备都支持MPT 和 END 功能
const isShowMPT_END = computed(() => [...JingTaiDeviceList, ...JingTaiV2DeviceList, ...HuoChaiRenDevices].includes(DeviceManager.instance.state.currentPid))

const initSupportKME = async () => {
  isSupportKME.value = await DeviceCapability.isSupportKME()
}
// 查找当前按键是否设置了宏功能
const findCurrentKeyHasMacro = () => {
  const key = operate.currentKey.value
  if (key == null) {
    return false
  }
  const macros = setData.getData().Layout.Macros
  if (macros[key]) {
    return true
  }
  return false
}
const check_macro = (): boolean => {
  let fnCount = Object.values(setData.getData().LayoutFn.Macros).length
  let count = Object.values(setData.getData().Layout.Macros).length

  if (DeviceManager.instance.state.currentDevice.Limit.MacroIndexLen <= fnCount + count) {
    if (findCurrentKeyHasMacro()) {
      return true
    }
    enableDialog(t('macro_index_limit_tip'), DialogType.notice, false)
    return false
  }
  return true
}

const isSelfDevMix = computed(() => {
  return specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)
})

watch(operate.fnCheck, (_value: boolean) => {
  setTimeout(() => {
    uploadData()
  }, 100)
})

watch(operate.currentKey, (_value: KK | null) => {
  uploadData()
})

// 此按键已在Fn层设置了高级按键功能，无法在普通层再次设置。
// 此按键已在普通层设置了高级按键功能，无法在Fn层再次设置。
const uploadData = async () => {
  const kk = operate.currentKey.value
  const isFn = operate.fnCheck.value

  // 初始化状态
  actionMessage.value = ''
  isShowNormal.value = true
  isShowMacro.value = true
  isShowMagnet.value = getCurrentDevice.value.magneticAxis

  await initSupportKME()
  await initSupportRS()

  const data = setData.getData()
  if (!data || !data.Layout || !data.LayoutFn) return

  const context = {
    kk,
    isFn,
    data,
    supportKME: isSupportKME.value,
    t,
  }

  const visibility = resolveActionVisibility(context)
  actionMessage.value = visibility.actionMessage
  isShowNormal.value = visibility.isShowNormal
  isShowMacro.value = visibility.isShowMacro
  isShowMagnet.value = visibility.isShowMagnet
  isSupportKME.value = visibility.isSupportKME

  // 5. 模式纠正：如果当前模式被隐藏，自动跳回常规改键
  checkCurrentSetTypeVisibility()
}

/**
 * 纠正当前选中模式：如果由于冲突导致当前 SetType 不可见，则强制切回常规改键
 */
const checkCurrentSetTypeVisibility = () => {
  const current = actionSet.setType.value

  if (
    !isActionSetTypeVisible(current, {
      actionMessage: actionMessage.value,
      isShowNormal: isShowNormal.value,
      isShowMacro: isShowMacro.value,
      isShowMagnet: isShowMagnet.value,
      isSupportKME: isSupportKME.value,
    })
  ) {
    actionSet.changeSetType(SetType.routine)
  }
}
</script>

<style lang="less" scoped>
.set_type_bg {
  width: 240px;
  flex-shrink: 0;
  padding: 20px 14px;
  display: flex;
  flex-direction: column;
  z-index: 2;
  overflow-y: auto;
  border-right: 1px solid rgba(0, 0, 0, 0.04);
  height: 100%;

  /* 优雅隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  -webkit-app-region: no-drag;

  .set_type_container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .set_type_box {
    display: flex;
    flex-direction: column;
    gap: 6px; /* 紧凑但清晰的间距 */
    width: 100%;

    .set_type {
      padding: 12px 14px;
      cursor: pointer;
      position: relative;
      border-radius: var(--radius-m);
      transition: var(--transition-base);
      background: transparent;
      border: 1px solid transparent;
      display: flex;
      align-items: center;
      gap: 12px;

      .set_type_icon_wrapper {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-m);
        background: rgba(0, 0, 0, 0.03);
        flex-shrink: 0;
        transition: var(--transition-base);

        .set_type_icon {
          display: block;
          width: 20px;
          height: 20px;
          background: rgba(0, 0, 0, 0.5);
          -webkit-mask-image: var(--set-type-icon);
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-position: center;
          -webkit-mask-size: contain;
          mask-image: var(--set-type-icon);
          mask-repeat: no-repeat;
          mask-position: center;
          mask-size: contain;
          opacity: 0.6;
          transition: var(--transition-base);
        }
      }

      .set_type_info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0;
        flex: 1;
        padding-right: 18px; /* 为右侧出现的提示图标预留空间 */

        .set_type_title {
          font-size: 13px;
          font-weight: 700;
          color: var(--color-dark);
          line-height: 1.2;
          opacity: 0.8;
          white-space: normal; /* 允许标题换行 */
          word-break: break-word; /* 确保长单词也能换行 */
        }

        .set_type_content {
          margin-top: 2px;
          font-size: 10px;
          color: var(--color-text-hint);
          line-height: 1.4; /* 增加行高提升换行后的可读性 */
          opacity: 0.5;
          white-space: normal; /* 允许换行以显示完整描述 */
          word-break: break-word; /* 确保长内容能正确换行 */
        }
      }

      .set_type_hint {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        transition: var(--transition-base);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.6);
        transform: translateX(4px); /* 悬停轻微右移 */

        .set_type_icon_wrapper {
          background: rgba(255, 255, 255, 0.8);
          .set_type_icon {
            opacity: 1;
            background: var(--color-dark);
          }
        }

        .set_type_info {
          .set_type_title {
            opacity: 1;
          }
          .set_type_content {
            opacity: 0.8;
          }
        }

        .set_type_hint {
          opacity: 1;
        }
      }

      &.selected {
        background: #fff;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        transform: translateX(10px);
        border: 1px solid rgba(255, 255, 255, 0.8);

        .set_type_icon_wrapper {
          background: rgba(var(--color-brand-1-rgb), 0.05);
          .set_type_icon {
            opacity: 1;
            background: var(--brand-color-pure);
          }
        }

        .set_type_info {
          .set_type_title {
            color: var(--color-dark);
            opacity: 1;
          }

          .set_type_content {
            color: var(--brand-color-pure);
            opacity: 1;
          }
        }

        .set_type_hint {
          opacity: 1;
          background: rgba(var(--color-brand-1-rgb), 0.05);
          border-radius: 50%;
        }

        /* 选中的左侧亮色指示器 - 匹配图中的橙色呼吸感 */
        &::before {
          content: '';
          position: absolute;
          left: -4px;
          top: 50%;
          transform: translateY(-50%);
          width: 5px;
          height: 32px;
          background: var(--brand-color-pure);
          border-radius: var(--radius-pill);
          box-shadow: 0 0 12px rgba(var(--color-brand-1-rgb), 0.4);
        }
      }
    }
  }

  .message {
    margin: 0 4px 12px 4px;
    padding: 8px 12px;
    background: rgba(var(--color-brand-2-rgb), 0.08);
    border: 1px solid rgba(var(--color-brand-2-rgb), 0.15);
    border-radius: var(--radius-s);
    font-size: 11px;
    color: var(--color-brand-2);
    display: flex;
    align-items: flex-start;
    gap: 6px;
    line-height: 1.4;

    .image {
      width: 14px;
      height: 14px;
      margin-top: 1px;
      flex-shrink: 0;
    }
  }
}
</style>
